<div style="display:grid; justify-content: center; justify-items: center; margin-top: 50px;">
    <img src="assets/images/construction-rounded.svg" style="height:300px;width:300px">
    <div style="font-size: xx-large;">PAGE UNDER CONSTRUCTION</div>
    <a routerLink="/converter" style="font-size: large;">Return to Converter Functions</a>
</div>